<template lang="pug">
  include /mixins
  div.relative
    d-control-static-input(
      class="d-control-input--variant_5"
      v-model='query'
      :prepend-icon="icon"
      :name='query'
      autocomplete='off'
      label='caption'
      :placeholder='_("Пошук")',
      @input='debounceAction'
    )
    +b.label-input.--another
      +e.SPAN.text.ds-caption.--size-12.--color-gray-light.--weight-bold {{ _('Искать информацию')}}
</template>
<script>
import {
  isEmpty,
} from '@aspectus/vue-utils'
import { debounce } from 'vue-debounce'

export default {
  name: 'SimpleSearch',
  props: ['value'],
  data() {
    return {
      debounceAction: null,
      query: '',
      icon: 'icon-search',
    }
  },
  watch: {
    value(nval) {
      if ('undefined' === typeof nval) {
        const empty = ''
        this.query = this.normalizeFrom(empty)
      } else {
        if (0 > nval.length) {
          this.icon = ''
        } else {
          this.icon = 'icon-search'
        }
        this.query = this.normalizeFrom(nval)
      }
    },
  },
  mounted() {
    const delay = 2000
    this.debounceAction = debounce(() => {
      this.submit()
    }, delay)
    this.query = this.normalizeFrom(this.value)
  },
  methods: {
    submit() {
      const length = 2
      const zero = 0
      if (this.query.length >= length) {
        this.$emit('input', [this.query])
        return
      }
      if (this.query.length === zero) {
        this.$emit('input', [])
      }
    },
    normalizeFrom(value) {
      if (isEmpty(value)) return ''
      const query = value[0]
      return query
    },
  },
}
</script>
